import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    asunto: {
      whiteSpace: "initial",
      fontSize: 16,
      fontWeight: 500,
      color: "#3b465c",
    },
    fecha: {
      color: "rgba(59, 70, 92, 0.6)",
    },
  });
